import { render, staticRenderFns } from "./documentPermission.vue?vue&type=template&id=1b0416ae&scoped=true"
import script from "./documentPermission.vue?vue&type=script&lang=js"
export * from "./documentPermission.vue?vue&type=script&lang=js"
import style0 from "./documentPermission.vue?vue&type=style&index=0&id=1b0416ae&prod&lang=scss"
import style1 from "./documentPermission.vue?vue&type=style&index=1&id=1b0416ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0416ae",
  null
  
)

export default component.exports